import { useUniversityContext, useUserContext } from '@/context';

export interface FaceEnrollmentModule {
  forceEnrollment: boolean;
  visible: boolean;
}

export function useFaceEnrollmentModule(): FaceEnrollmentModule {

  const { university } = useUniversityContext();
  const { profile } = useUserContext();

  if (!university?.samad?.faceEnrollment || !profile?.changeProfilePicturePermission) {
    return {
      visible: false,
      forceEnrollment: false
    };
  }

  // Backward Compatibility with backend < 64
  if (profile?.group == null) {
    return {
      visible: true,
      forceEnrollment: profile?.faceMatching
    };
  }

  const groupAccess = profile?.group?.foodDeliveryBasedOnFacialRecognition;

  // Do not force if groupAccess is false and ignore faceMatching parameter
  if (!groupAccess) {
    return {
      visible: true,
      forceEnrollment: false
    };
  }

  return {
    visible: true,
    forceEnrollment: profile?.faceMatching
  };

}

export default useFaceEnrollmentModule;
